export default "__VITE_ASSET__BdXgfeo5__"